import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { RendererType } from '../../../../data-models/field-definition';
import { ISelectMeta } from '../../../../data-models/field3.data-model';
import { captablesByCompanyStateJ } from '../../../../services/state/CapTableDataStateJ';
import { createFormField } from '../../../../view-models/form.view-model';
import { selectedCompanyIdProfileAtom } from '../../state/UIStateJ';
import { CaptableSourceMap, isDuplicateSource } from '../captable-utils';

export function useCaptableSourceSelector() {
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const captablesForCompanyRaw = useAtomValue(captablesByCompanyStateJ(companyId ?? -1));

  return useMemo(() => {
    const captablesForCompany = captablesForCompanyRaw ?? [];
    const options = captablesForCompany.filter(isDuplicateSource);
    return createFormField<ISelectMeta<number>>({
      key: 'selectedCaptable',
      label: '',
      dataType: 'string',
      renderer: RendererType.singleSelect,
      rendererMeta: {
        values: options.map((opt) => {
          return {
            value: opt.id,
            displayName: `${CaptableSourceMap[opt.source]} ${opt.primary ? '(Primary)' : ''}`,
          };
        }),
        multi: false,
      },
      disableClearable: true,
    });
  }, [captablesForCompanyRaw]);
}
